export const formatDateToDateTimeString = (date: Date | string) => {
  if (date) {
    const newDate = new Date(date);
    return `${newDate.toLocaleDateString()} ${newDate.toLocaleTimeString()}`;
  }
  return null;
};
